import { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'

type GuardProps = {
  children: ReactNode
}

const GuestGuard = (props: GuardProps) => {
  const { children } = props
  const { isLoggedIn } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/home', { replace: true })
    }
  }, [isLoggedIn, navigate])

  return children
}

export default GuestGuard
